import styled from 'styled-components';

import { IconRegularGift, ProductLabel, theme } from '@notino/react-styleguide-v20';

import { AdditionalProductLabel } from './components/AdditionalProductLabel';

interface IStyledProductItemBodyProps {
  disabled?: boolean;
}

export const StyledProductItemBody = styled.div<IStyledProductItemBodyProps>`
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${({ disabled }) => (disabled ? theme.color.text.disabled : theme.color.text.primary)};
`;

export const StyledProductLink = styled.a<IStyledProductItemBodyProps>`
  text-decoration: none;
  color: ${({ disabled }) => (disabled ? theme.color.text.disabled : theme.color.text.primary)};

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledSubName = styled.span<IStyledProductItemBodyProps>`
  display: block;
  color: ${({ disabled }) => (disabled ? theme.color.text.disabled : theme.color.text.secondary)};
`;

export const StyledUsedProduct = styled.div`
  color: ${theme.color.text.tertiary};
`;

export const StyledAdditionalProductLabel = styled(AdditionalProductLabel)`
  display: block;
`;

export const StyledInSaleTag = styled(ProductLabel)`
  text-transform: none;
`;

export const SLoyaltyRewardLabel = styled(ProductLabel)`
  text-transform: none;
  border-radius: 6.25rem;
  color: #8e437a;
  background-image: linear-gradient(#fbeef6, #f4f5fb);
  font-size: 0.75rem;
  font-weight: bold;
`;

export const SLoyaltyRewardGiftIcon = styled(IconRegularGift)`
  height: 1rem;
  width: 1rem;
  color: #8e437a;
  margin-right: 0.375rem;
`;

export const SLoyaltyRewardWrapper = styled.div`
  display: flex;
  align-items: center;
`;
